import { getAllElementsInColsInLayoutComponent, isSsrPage } from "utils"
class routerNav {
  constructor(vue) {
    this.content = vue
  }
  init() {
    this.initStyle()
  }
  initStyle() {
    const { activeLinkColor, primaryLinkColor } = this.content.options
    const allElementInLayout = getAllElementsInColsInLayoutComponent(this.content.options.rows)
    const changeColorEle = ["cxShape", "cxText"]
    const baseId = {
      container_id: this.content.myid.container_id,
      rect_id: this.content.myid.rect_id
    }
    for (let uid in allElementInLayout) {
      const routerLinkPageId = allElementInLayout[uid].componentBoxOptions.routerLinkPageId
      allElementInLayout[uid].elementOptions.forEach(elementInLayout => {
        const { innerElement, elementInLayoutId } = elementInLayout
        //找到了 说明是需要改颜色的组件
        if (changeColorEle.find(it => it === innerElement)) {
          //url地址与当前单元格绑定的地址一致，则更新为选中态颜色，否则更新为默认态颜色
          const param = {
            elementInLayoutId: elementInLayoutId,
            uid,
            ...baseId,
            option_name: innerElement === "cxShape" ? "iconColor" : "color",
            option_val:
              (routerLinkPageId?.length || 0 > 5) && window.location.href.includes(routerLinkPageId)
                ? activeLinkColor
                : primaryLinkColor
          }
          this.content.$store.dispatch(this.content.request_prefix + "/changeLayoutOption", param)
        }
      })
    }
  }
}
export default {
  data() {
    return {
      routerNav: new routerNav(this)
    }
  },
  methods: {
    routerNavPlugin() {
      this.routerNav.init()
      this.$watch(
        "options",
        function () {
          this.routerNav.init()
        },
        { deep: true }
      )
    }
  }
}
